module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editor"
  }, [_c('div', {
    staticClass: "inputs"
  }, [_c('div', {
    staticClass: "input"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("Grid Template Areas: " + _vm._s(_vm.areas.length))]), _vm._v(" "), _c('button', {
    staticClass: "input__button input__button--add",
    on: {
      "click": _vm.addArea
    }
  }, [_vm._v("Add an area")]), _vm._v(" "), (_vm.overflowAreas.length) ? _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.overflowAreas.length) + " area" + _vm._s(_vm.overflowAreas.length === 1 ? '' : 's') + " cannot fit in grid. Add a " + _vm._s(_vm.overflowAreas.filter(function (area) { return area.x < 0; }).length ? 'row or column' : _vm.overflowAreas.filter(function (area) { return area.x > _vm.columns.length - 1; }).length ? 'column' : 'row') + ".")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("Grid Template Columns: " + _vm._s(_vm.columns.length))]), _vm._v(" "), _vm._l((_vm.columns), function(column, index) {
    return _c('div', [_vm._v("\n          Column " + _vm._s(index + 1) + " \n          "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (column.size),
        expression: "column.size"
      }],
      staticClass: "input__input--size",
      attrs: {
        "type": "number",
        "name": "size",
        "size": "5",
        "disabled": column.units === 'auto'
      },
      domProps: {
        "value": (column.size)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          column.size = $event.target.value
        }
      }
    }), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (column.units),
        expression: "column.units"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          column.units = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "val": "auto"
      }
    }, [_vm._v("auto")]), _vm._v(" "), _c('option', {
      attrs: {
        "val": "%"
      }
    }, [_vm._v("%")]), _vm._v(" "), _c('option', {
      attrs: {
        "val": "em"
      }
    }, [_vm._v("em")]), _vm._v(" "), _c('option', {
      attrs: {
        "val": "rem"
      }
    }, [_vm._v("rem")]), _vm._v(" "), _c('option', {
      attrs: {
        "val": "fr"
      }
    }, [_vm._v("fr")]), _vm._v(" "), _c('option', {
      attrs: {
        "val": "px"
      }
    }, [_vm._v("px")]), _vm._v(" "), _c('option', {
      attrs: {
        "val": "vw"
      }
    }, [_vm._v("vw")])]), _vm._v(" "), (_vm.columns.length > 1) ? _c('button', {
      staticClass: "input__button input__button--remove",
      on: {
        "click": function($event) {
          _vm.removeColumn(column)
        }
      }
    }, [_vm._v("X")]) : _vm._e()])
  }), _vm._v(" "), _c('button', {
    staticClass: "input__button input__button--add",
    on: {
      "click": _vm.addColumn
    }
  }, [_vm._v("Add Column")]), _vm._v("Remove Column")], 2), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("Grid Template Rows: " + _vm._s(_vm.rows.length))]), _vm._v(" "), _vm._l((_vm.rows), function(row, index) {
    return _c('div', [_vm._v("\n          Row " + _vm._s(index + 1) + " \n          "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.size),
        expression: "row.size"
      }],
      staticClass: "input__input--size",
      attrs: {
        "type": "number",
        "name": "size",
        "size": "5",
        "disabled": row.units === 'auto'
      },
      domProps: {
        "value": (row.size)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          row.size = $event.target.value
        }
      }
    }), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.units),
        expression: "row.units"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          row.units = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "val": "auto"
      }
    }, [_vm._v("auto")]), _vm._v(" "), _c('option', {
      attrs: {
        "val": "%"
      }
    }, [_vm._v("%")]), _vm._v(" "), _c('option', {
      attrs: {
        "val": "em"
      }
    }, [_vm._v("em")]), _vm._v(" "), _c('option', {
      attrs: {
        "val": "rem"
      }
    }, [_vm._v("rem")]), _vm._v(" "), _c('option', {
      attrs: {
        "val": "fr"
      }
    }, [_vm._v("fr")]), _vm._v(" "), _c('option', {
      attrs: {
        "val": "px"
      }
    }, [_vm._v("px")]), _vm._v(" "), _c('option', {
      attrs: {
        "val": "vh"
      }
    }, [_vm._v("vh")])]), _vm._v(" "), (_vm.rows.length > 1) ? _c('button', {
      staticClass: "input__button input__button--remove",
      on: {
        "click": function($event) {
          _vm.removeRow(row)
        }
      }
    }, [_vm._v("X")]) : _vm._e()])
  }), _vm._v(" "), _c('button', {
    staticClass: "input__button input__button--add",
    on: {
      "click": _vm.addRow
    }
  }, [_vm._v("Add Row")])], 2), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("Grid Column Gap")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.colGap.size),
      expression: "colGap.size"
    }],
    staticClass: "input__input--size",
    attrs: {
      "type": "number",
      "name": "size",
      "size": "5"
    },
    domProps: {
      "value": (_vm.colGap.size)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.colGap.size = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.colGap.units),
      expression: "colGap.units"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.colGap.units = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "val": "%"
    }
  }, [_vm._v("%")]), _vm._v(" "), _c('option', {
    attrs: {
      "val": "em"
    }
  }, [_vm._v("em")]), _vm._v(" "), _c('option', {
    attrs: {
      "val": "rem"
    }
  }, [_vm._v("rem")]), _vm._v(" "), _c('option', {
    attrs: {
      "val": "px"
    }
  }, [_vm._v("px")])])]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("Grid Row Gap")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rowGap.size),
      expression: "rowGap.size"
    }],
    staticClass: "input__input--size",
    attrs: {
      "type": "number",
      "name": "size",
      "size": "5"
    },
    domProps: {
      "value": (_vm.rowGap.size)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rowGap.size = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rowGap.units),
      expression: "rowGap.units"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rowGap.units = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "val": "%"
    }
  }, [_vm._v("%")]), _vm._v(" "), _c('option', {
    attrs: {
      "val": "em"
    }
  }, [_vm._v("em")]), _vm._v(" "), _c('option', {
    attrs: {
      "val": "rem"
    }
  }, [_vm._v("rem")]), _vm._v(" "), _c('option', {
    attrs: {
      "val": "px"
    }
  }, [_vm._v("px")])])]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("Justify Items")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.justify.value),
      expression: "justify.value"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.justify.value = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "val": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "val": "stretch"
    }
  }, [_vm._v("stretch")]), _vm._v(" "), _c('option', {
    attrs: {
      "val": "center"
    }
  }, [_vm._v("center")]), _vm._v(" "), _c('option', {
    attrs: {
      "val": "start"
    }
  }, [_vm._v("start")]), _vm._v(" "), _c('option', {
    attrs: {
      "val": "end"
    }
  }, [_vm._v("end")])])]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("Align Items")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.align.value),
      expression: "align.value"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.align.value = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "val": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "val": "stretch"
    }
  }, [_vm._v("stretch")]), _vm._v(" "), _c('option', {
    attrs: {
      "val": "center"
    }
  }, [_vm._v("center")]), _vm._v(" "), _c('option', {
    attrs: {
      "val": "start"
    }
  }, [_vm._v("start")]), _vm._v(" "), _c('option', {
    attrs: {
      "val": "end"
    }
  }, [_vm._v("end")])])])]), _vm._v(" "), _c('div', {
    staticClass: "css-output"
  }, [_c('button', {
    staticClass: "input__button button--clipboard",
    on: {
      "click": function($event) {
        _vm.copyTextToClipboard(_vm.css)
      }
    }
  }, [_vm._v("Copy to Clipboard")]), _vm._v("\n      CSS: \n      " + _vm._s(_vm.css) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cbe4856","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Editor.vue
// module id = 71
// module chunks = 1